export function entryFromArray(label: string, array: Array<string>) {
  return array.map((value) => ({
    label,
    value,
  }));
}
